import {useState} from 'react';
import {Button, Modal} from 'semantic-ui-react';
import PropTypes from 'prop-types';
import Code from './code';

function CreateOrderModal(props) {
  const [code, setCode] = useState(null);
  if (!props.open) return null;

  return (
    <Modal
      closeIcon
      closeOnEscape
      closeOnDimmerClick
      open={props.open}
      onClose={props.onCancel}
      size='small'
    >
      <Modal.Header>آیا از خرید پکیج زیر مطمئن هستید؟</Modal.Header>
      <Modal.Content>
        <div>
          <p>
            <span className='text-medium'>نام پکیج: </span>
            <span>{props.package.name}</span>
          </p>
          <p>
            <span className='text-medium'>مدت اعتبار مشاوره: </span>
            <span>{props.package.duration}</span>
            <span> روز</span>
          </p>
          <p>
            <span className='text-medium'>هزینه پکیج: </span>
            <span>{props.package.price?.toLocaleString()}</span>
            <span> ریال</span>
          </p>
          {code && (
            <>
              <p>
                <span className='text-medium'>مقدار تخفیف: </span>
                <span>{code.amount}</span>
                <span> درصد</span>
              </p>
              <p>
                <span className='text-medium'>هزینه نهایی: </span>
                <span>{(props.package.price * (100 - code.amount) / 100).toLocaleString()}</span>
                <span> ریال</span>
              </p>
            </>
          )}
        </div>
        <div className='my-4'>
          <Code code={code} setCode={setCode}/>
        </div>
      </Modal.Content>
      <Modal.Actions>
        <Button
          positive
          content='بلی'
          onClick={() => props.onConfirm(code ? code.text : null)}
        />
        <Button
          negative
          content='خیر'
          onClick={props.onCancel}
        />
      </Modal.Actions>
    </Modal>
  );
}

CreateOrderModal.propTypes = {
  open: PropTypes.bool.isRequired,
  package: PropTypes.object.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};

export default CreateOrderModal;
